import { createContext } from "react";

export const PhotographyContext = createContext();
export const PhotographyProvider = PhotographyContext.Provider;
export const PhotographyConsumer = PhotographyContext.Consumer;
